angular.module('unica_room.room_controllers')

.controller('RoomListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	RoomListService, RoomDeleteService
) {
	$scope.roomList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadRooms = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		RoomListService
			.list( $scope.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.roomList = $scope.roomList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadRooms();

	$scope.deleteRoom = function(roomId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare la stanza?',
			text: 'Confermi la cancellazione della stanza?'
		}).then(function() {

			$scope.showLoader();
			RoomDeleteService
				.delete( roomId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.roomList, function(room, key) {
							if ( room.id == roomId ) {
								$scope.roomList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Stanza eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

;